/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { dependencyEdgeEntrySchema } from './dependencyEdgeEntrySchema';

export const dependencyAnalysisSchema = z.object({
  get added() {
    return z.array(dependencyEdgeEntrySchema);
  },
  addedCount: z.int(),
  get removed() {
    return z.array(dependencyEdgeEntrySchema);
  },
  removedCount: z.int(),
});
